import { Editor, Text } from 'slate';
import { StartStopWord } from '@utils/types/editors/utils.ts';
import { DocumentTranscriptTextV1 } from '@utils/types/editors/transcripts/transcript.ts';

export const getSelectedWordFromSelection = (
  editor: Editor
): StartStopWord | null => {
  if (!editor.selection) return null;

  const nodes = Array.from(
    Editor.nodes(editor, {
      at: editor.selection,
      match: n => Text.isText(n)
    })
  );

  if (nodes.length > 0) {
    const firstNode = nodes[0][0] as DocumentTranscriptTextV1;
    const lastNode = nodes[nodes.length - 1][0] as DocumentTranscriptTextV1;

    if (
      typeof firstNode.start === 'number' &&
      typeof lastNode.stop === 'number'
    ) {
      return {
        start: firstNode.start,
        stop: lastNode.stop
      };
    }
  }

  return null;
};
